export default "__VITE_ASSET__9639abc9__"